import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { RouterProvider } from "react-router-dom";
import { reactQueryClient } from '~/shared/contexts/CommonAppContext';
import router from '../routes/coaching-app-routes';

const CoachingApp = () => {
  return (
    <QueryClientProvider client={reactQueryClient} >
      <RouterProvider router={router} />

      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}

export default CoachingApp;